
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import OCROrderApi from "@/api/ocr-order-api";
import UploadApi from "@/api/upload-api";
import OcrOrder from "./config";
import ItemEditor from "./item-editor.vue";
// import ItemEditorCustom from "./item-editor-custom.vue";
import { Toast } from "vant";

type ImgFile = UploadApi.IFileDetailView & { url: string }
type MainType = OcrOrder.DetailItem
type OrderType = OcrOrder.IOcrOrderListItemWithDetail;
@Component({ name: "item-view", components: { ItemEditor } })
export default class ItemView extends Vue {
    /**是否显示明细内容 */
    vShow = false;
    innerItems: MainType[] = [];

    created() { }
    mounted() { }
    @Prop({ required: true }) datasource!: MainType[]

    @Prop() order!: OrderType

    selectItem: MainType | null = null

    get isCustom() { return this.order?.IsCustom }

    @Watch("vShow")
    @Watch("datasource", { immediate: true })
    datasourcChnage() {
        if (this.vShow) return;
        this.innerItems = this.datasource;
    }

    getImage(m: MainType) {
        // console.error("mmm", m)
        return m.files!.length ? m.files![0].url : undefined;
    }

    itemOnclick(e: MainType) {
        if (this.isCustom) {
            this.$router.push({ name: "ocr-order-detail-customer-editor", query: { id: e.Id, orderId: this.order.Id } as any })
            return;
        }
        this.selectItem = e;
        this.vShow = true;
    }

    editOnSwipe(step: number) {
        var idx = this.innerItems.findIndex(e => e == this.selectItem);
        idx += step;
        if (step > 0) {
            if (idx >= this.innerItems.length) return Toast({ message: "已是最后一项", icon: "fail" });
        }
        else if (idx < 0) return Toast({ message: "已是最第一项", icon: "fail" });
        this.selectItem = this.innerItems[idx];
    }
}
